import { Typography, Grid } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { LessonTeacher } from "../../Objects/OnlineLesson";

export interface TeacherDeldateProps {
    teacherData: LessonTeacher
}

const TeacherDeldate: React.FC<TeacherDeldateProps> = ({
    teacherData
}) => {
    return teacherData.delete_at ? (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="caption" sx={{ color: "#333399" }}>解除日</Typography>
            </Grid>
            <Grid item>
                <Typography variant="body1">{format(new Date(teacherData.delete_at), "yyyy年MM月dd日")}</Typography>
            </Grid>
        </Grid>
    ) : <></>;
}

export default TeacherDeldate